module.exports = __webpack_public_path__ + "static/media/social1.d4194325.svg";